{
  "#WORK_NOTE": {
    "MENU": {
      "LIST": "Arbeitsscheine",
      "QUERY": "Abfrage"
    },
    "TITLE": "Arbeitsschein",
    "LIST": {
      "TITLE": "Arbeitsscheine",
      "EMPTY": "Keine offenen Arbeitsscheine"
    },
    "QUERY": {
      "QUERY": {
        "TITLE": "Abfrage",
        "SUBMIT": "Abfragen",
        "RESET": "Zurücksetzen",
        "QUICK_LINKS": {
          "TITLE": "Schnellabfrage",
          "CURRENT_WEEK": "Diese Woche",
          "LAST_WEEK": "Letzte Woche",
          "CURRENT_MONTH": "Dieses Monat",
          "MUSTER": "Muster"
        },
        "MANUAL": "Manuelle Abfrage"
      },
      "QUERY_RESULT": {
        "TITLE": "Abfrageergebniss",
        "FILTER": "Angewendete Filter"
      }
    },
    "DETAIL": {
      "SIGN_HINT": "Tippen um eine Unterschrift hinzuzufügen",
      "DRAW_PAD": "Zeichenfeld",
      "KOPFDATEN": "Kopfdaten",
      "BAUSTELLE": "Baustelle",
      "KOPFTEXT": "Kopftext",
      "TEMP_MIN": "Temperatur min.",
      "TEMP_MAX": "Temperatur max.",
      "OBJEKT": "Objekt",
      "WEATHER": "Wetter",
      "IMAGES": "Bilder",
      "POSITIONS": "Positionen",
      "SIGNATURE": "Unterschrift",
      "SAVE_BTN": "Speichern",
      "SAVE_AND_FINISH_BTN": "Speichern & Abschließen",
      "CLOSE_BTN": "Schließen",
      "DONE_BTN": "Alles erledigt",
      "VERMERK": "Vermerk",
      "VERMERK_INTERN": "Vermerk Intern",
      "GEO": {
        "TITLE": "Geodaten",
        "GOOGLE_MAPS": "In Maps öffnen",
        "GPSLAENGE": "Längengrad",
        "GPSBREITE": "Breitengrad"
      }
    },
    "DIALOGS": {
      "NOTES": {
        "TITLE": "Vermerk hinzufügen/bearbeiten"
      },
      "SIGNATURE": {
        "TITLE": "Unterschrift hinzufügen",
        "SAVE_BTN": "Speichern",
        "CANCEL_BTN": "Abbrechen"
      },
      "FINISH": {
        "TITLE": "Arbeitsschein erledigen?",
        "INFO": "Hiermit wird der Arbeitsschein als erledigt markiert. Mit Beistrich getrennt können bei der E-Mail Adresse mehrere Empfänger angegeben werden. Bleibt das E-Mail Feld leer, wird nur eine interne E-Mail versendet.",
        "SUBMIT_BTN": "Abschließen",
        "SAVE_BTN": "Nur Speichern"
      },
      "CREATE": {
        "TITLE": "Position erstellen"
      }
    },
    "MESSAGES": {
      "ONLY_NUMERIC": "Nur numerische Werte erlaubt!",
      "DONE_ERROR_SUBJECT": "Fehler beim Abschließen",
      "DONE_ERROR_MESSAGE": "Aufgrund eines Fehlers konnte der Arbeitsschein nicht abgeschlossen werden",
      "DONE_SUCCESS_SUBJECT": "Arbeitsschein erfolgreich abgeschlossen",
      "DONE_SUCCESS_MESSAGE": "Der Arbeitsschein wurde als erledigt markiert und ist somit abgeschlossen.",
      "SAVE_ERROR_TITLE": "Speichern nicht möglich!",
      "SAVE_ERROR_MESSAGE": "Bitte überprüfen Sie die Kopfdaten!",
      "SAVE_SUCCESS_TITLE": "Der Arbeitsschein wurde gespeichert",
      "SAVE_SUCCESS_MESSAGE": ""
    },
    "WIDGETS": {
      "SUMMARY": "Sie haben {{count}} offene Arbeitsscheine",
      "LINK": "Anzeigen"
    }
  }
}
